import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../api/axios';
import requests from '../../../api/requests';
import { scrollLock as ScrollLock, scrollUnlock as ScrollUnlock } from './scrollLock';

const initialState = {
  mode: false,
  noticeDetail: []
};

export const getNoticeDetail = createAsyncThunk('noticePopup/getNoticeDetail', async seq => {
  let seqNum = seq.seq
  if(seqNum !== ''){
    const res = await axios.get(requests.NOTICE_LIST + '/' + seqNum);
    let noticeDetailData = res.data.data;
    return noticeDetailData;
  }
});

export const noticePopupSlice = createSlice({
  name: 'noticePopup',
  initialState,
  reducers: {
    noticePopupShow: (state) => {
      state.mode = true;
      ScrollLock();
    },
    noticePopupHide: (state) => {
      state.mode = false;
      ScrollUnlock();
    },
  },
  extraReducers: builder => {
    builder.addCase(getNoticeDetail.fulfilled, (state, { payload }) => {
        state.noticeDetail = payload.noticeDetail;
    });
  }, 
});

export const { noticePopupShow, noticePopupHide} = noticePopupSlice.actions;

export default noticePopupSlice;
